export default {
  navigator: {
    home: 'Главная страница',
    achievements: 'Реультаты научного исследования',
    researcher: 'Научные сотрудники',
    ins: 'Учреждения',
    isme: 'Утверждение результатов',
    apply: 'Запрос на обслуживание'
  },
  home: {
    title: 'Институциональный репозиторий Университета МГУ-ППИ в Шэньчжэне',
    introduce: 'Университет МГУ-ППИ в Шэньчжэне это китайско-иностранный совместный университет с независимым статусом юридического лица, созданный Шэньчжэньским муниципальным народным правительством, Пекинским технологическим институтом и Московским государственным университетом имени М.В. Ломоносова в соответствии с консунсусом, достигнутым председателем Си Цзиньпином и президентом России Владимиром Путиным. Поставив перед собой цель создать международный комплекстный исследовательский университет мирового уровня с уникальным характеристиками, университет стремится обеспечить элитное образование, научные исследования и инновационную деятельность высокого уровня, и был офоциально учреждён Министерством образования Китайской Народной Республики в октябре 2016 года, в 2017 году принял первых студентов бакалавриата и магистратуры, в 2018 году - первых аспирантов, в 2020 году - был разрешенно создание постдокторских инновационно-практических баз, в 2021 году был выбран одним из университетов в провиции Гуандун.',
    insRepository:"База институциональных знаний",
    article: 'Статьи',
    patent: 'Патенты',
    researcher: 'Научные сотрудники',
    software_copyright: 'Программное обеспечение',
    award: 'Награды',
    project: 'Проекты',
    report: 'Доклад',
    book: 'Монография',
    data: 'Данные',
    news: {
      left_title: 'Последние результаты научных исследований',
      right_title: 'Темы институциональных исследований',
      more: 'Больше.',
    },
    login: 'Вход',
    signout: 'Выход' ,
    settings: 'Управление аккаунт' ,
    profile: 'Личный кабинет',
    historySearch:'История поиска',
    history:'История посмотра',
    search: {
      placeholder: 'Найти, что вам интересно',
      advanceSearch: 'Расширенный поиск',
      search: 'Поиск',
      topic: 'Тема',
    },
    appJoin: "Заявление о приеме",
    ins: "Учреждения",
    colleges: "Университеты",
    cas: "Академия наук Китая",
    scholar_count: "Количество ученых",
    fruit_count: "Количество результатов",
    journal_article_submit:"Сдача на хранение периодических документов",
    person_fruit_submit:"Сдача на хранение личных результатов",
  },
  explore: {
    category: 'Категории',
    years: 'Временной диапазон',
    start: 'Время начала',
    end: 'Время окончания',
    to: 'до',
    enter: 'Введите',
    exact: 'Точный',
    fuzzy: 'Неясный',
    reset: 'Сбросить условия',
    article: {
      title: 'Заглавие' ,
      keywords: 'Ключевые слова' ,
      author: 'Aвтор',
      institution: 'Учреждения',
      publication: 'Издание',
      abstract: 'Аннотация',
      doi: 'DOI',
      type: 'Тип документа',
      year: 'Год публикации',
      collect: 'Основная запись',
      lang: 'Язык проекта',
      authorIns: 'Авторское учреждение',
      fundIns: 'Финансирующие учреждения Фонда',
      licence: 'Разрешение на использование',
      subject: "Области знаний",
    },
    patent: {
      title: 'Название патента',
      inventor: 'Изобретатель',
      applicant: 'Заявитель',
      abstract: 'Аннотация',
      apply_number: 'Номер заявки',
      issue_number: 'Открытый номер',
      apply_year: 'Год подачи заявления',
      issue_year: 'Открытый год',
      subject: 'Области знаний',
      type: 'Тип патента',
      country: 'Страна/район',
      ipc: 'Классификация IPC',
      cpc: 'Классификация CPC',
    },
    report: {
      title: 'Заглавие',
      keywords: 'Ключевые слова',
      abstract: 'Аннотация',
      type: 'Тип доклада',
      institution: 'Учреждения',
      year: 'Время доклада',
      source: 'Источник доклада',
      subject: "Области знаний",
    },
    book: {
      title: "Название книги",
      publisher: "Издательство",
      author: "Aвтор",
      keywords: "Ключевые слова",
      abstract: "Аннотация",
      type: "Тип монографии",
      year: "Время публикации",
      ins: "Главный редактор",
      subject: "Области знаний",
    },
    scienceData: {
      title: 'Название книги',
      keywords: 'Ключевые слова',
      author: "Aвтор",
      abstract: 'Аннотация',
      subject: 'Области знаний',
      year: 'Время публикации',
      ins: 'Учреждения',
      licence: 'Разрешение на использование',
      data_type: 'Тип данных',
      file_type: 'Формат файла',
    },
    project: {
      title: 'Заглавие',
      keywords: 'Ключевые слова',
      author: 'Ответственное лицо',
      fundIns: 'Финансирующее учреждение',
      country: 'Финансируемые страны',
      abstract: 'Аннотация',
      underIns: 'Обслуживающая организация',
      startYear: 'Дата начала',
      status: 'Статус проекта',
      type: 'Тип проекта',
      lang: 'Язык проекта',
      fundAmout: 'Объем финансирования',
      subject: 'Области знаний',
    },
    award: {
      title: 'Заглавие',
      abstract: 'Аннотация',
      level: 'Уровень награды',
      category: "Уровень награды",
      year: "Время награждения",
      ti_ins: "Выдвинувшие кандидатуры органы",
      ins: "Организации, удостоенные наград",
    },
    software: {
      title: 'Заглавие',
      abstract: 'Аннотация',
      author: 'Авторское право',
      inventor: "Разработчик патента",
      year: "Дата выпуска",
      ins: "Органы власти",
      method: "Метод приобретения",
      range: "Рамки прав",
      registId: "Регистрационный номер",
      getMethod: "Режим приобретения прав",
    },
    institution: {
      title: 'Название учреждения',
      subject: 'Области исследований',
      intro: 'Введение',
      city: 'Город',
      country: 'Страна',
      tag: 'Метки',
      type: 'Тип учреждения',
    },
    all_selected: "Выбрать все",
    date_sorted: 'Сортировка по времени',
    related_sorted: 'Сортировка по релевантности',
    fulltext: "Полный текст",
    unit: 'ед.',
    filter: 'Фильтры',
    all: 'Все',
    related: 'Степень корреляции',
    name: 'Имя',
    count_paper: 'Количество сообщений',
    asc: "порядке возрастания",
    desc: "Порядок убывания",
    reasearch: "Направления исследований",
    people_category: "Категория персонала",
    research_unit: "Исследовательский модуль",
    units: 'Выберите исследовательский модуль',
    group: 'Пожалуйста, выберите группу',
    empty: 'Нет данных',
    selectCondtion: 'Фильтры',
    allDelete: 'Очистить все',
    selected: 'Выбрано',
    cancelSelected: 'Отменить выбор',
    exportText: 'Экспорт',
  },
  service_apply: {
    label1:"Облако институциональных знаний PubScholar",
    label1_1:"Институциональная облачная платформа знаний PubScholar основана на трех аспектах: управление институциональными активами и услуги знаний Китайской академии наук, оценка институциональной конкуренции и оценка дисциплин и информационная безопасность сети платформы, Использование технологий больших данных и искусственного интеллекта для повышения уровня управления и глубины использования институциональных знаний, предоставления управления активацией институциональных научных результатов, демонстрации возможностей научных исследований за рубежом, многомерного статистического анализа результатов работы команды, поддержки институциональной конкуренции и оценки академической конкуренции, а также для оказания помощи исследователям в эффективном объединении академических ресурсов высокого уровня, открывая возможности для обмена и использования научных результатов. Платформа официально запущена в ноябре 2023 года, в настоящее время в ней размещено более 20 научно - исследовательских институтов и университетов.",
    label2: 'Платформа PubScholar Institutional Knowledge Cloud приглашает к участию',
    label3: 'Заявителями на платформу облачного сервиса институциональных репозиториев обычно являются руководители институциональных научно-технических подразделений или библиотек. Заявителю необходимо заполнить ',
    label3_1: ' и отправить ее администратору платформы, который рассмотрит заявку, состыкует данные учреждения с заявителем и откроет облачный сервис институциональной базы знаний.',
    label4: 'Процедура подачи заявления на проживание в учреждении (как правило, заявителем является НТУ или администратор библиотеки)',
    label5: '(1) Заявители посещают платформу Облако институциональных репозиториев, чтобы загрузить ',
    label5_1: ' и заполнить ее.',
    label6: '(2) Заявитель отправляет заполненную форму заявки по электронной почте администратору платформы hujy@mail.las.ac.cn.',
    label7: '(3) Администратор платформы рассмотрит заявку после ее получения, и цикл рассмотрения составит 3 рабочих дня.',
    label8: '(4) Стыковка данных с заявителями после проверки администратором платформы для завершения импорта, очистки и стандартизации институциональных данных.',
    label9: '(5) Администратор платформы открывает облачный сервис институциональноого репозитория для организации-заявителя и уполномочивает администратора организации управлять внутренней платформой управления институциональной базой знаний.',
    label10: 'Скачать бланк заявления на оказание услуг',
    label11: ' «Форма заявки на открытие облачного сервиса институциональных репозиториев» ',
    label12: 'Контакты платформы',
    label13: 'Вы можете связаться с нами, если у вас есть какие - либо запросы, вопросы или предложения в процессе использования Платформы, следующим образом, и мы будем серьезно относиться к вашим вопросам.',
    label14: 'Почтовый ящик: hujy@mail.las.ac.cn * zhangrumin@mail.las.ac.cn',
    label15: 'Тел.: 010 - 82628382'
  },
  footer: {
    operator: 'Национальная научная библиотека Китайской академии наук',
    operatorLabel: 'Действующие организации：',
    contactAddressLabel: 'Адрес：',
    contactAddress: 'Пекин, Район Хайдиан, д. 33, Северное четвертое кольцо Западной дороги' ,
    contactNumberLabel: 'Телефоны：',
    contactNumber: '010-82628382',
    copyright: 'Национальная научная библиотека Китайской академии наук, Все права защищены'
  }
}
